import { SystemMgmtService } from "../services/systemMgmt/systemMgmt.service";
import { store } from "../store/store";

export const SET_SOFTWARES = 'SET_SOFTWARES';
export const SET_MAILTEMPLATES = 'SET_MAILTEMPLATES';

export const fetchSoftwares = async () => {
    const res = await SystemMgmtService.getSoftwares();
    store.dispatch(setSoftwares(res));
}

export const fetchMailTemplates = async () => {
    const res = await SystemMgmtService.getMailTemplates();
    store.dispatch(setTemplates(res));
}

export const setSoftwares = (data: any) => {
    return {
        type: SET_SOFTWARES,
        data
    }
}

export const setTemplates = (data: any) => {
    return {
        type: SET_MAILTEMPLATES,
        data
    }
}
